import { useState } from "react";
import { InputFile } from "../../../components/Input/InputFile";
import logo from "../../../assets/recode_pro-logo-1.svg";
import exemplo from "../../../assets/exemplo.xlsx";
// import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFileArrowUp } from "@fortawesome/free-solid-svg-icons";
// import { faKey } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { AuthContext } from "../../../services/Auth";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import styles from "../../Sgr/Sgr.module.scss";
import { AlignCenter } from "../../../components/Box/Box";
import { ContainedBtn } from "../../../components/ButtonTypes/Button";
import Papa from "papaparse";
import { useRef } from "react";
import Swal from "sweetalert2";
import { swalTheme } from "../../../services/Swal";
// import { Link } from "react-router-dom";

function RecodeproAprovados() {
  // Parsed Data Response in array format
  const [tableRows, setTableRows] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [quantidadeDisplay, setQuantidadeDisplay] = useState(1);
  const { user } = useContext(AuthContext);
  const inputFile = useRef([]);

  const changeHandler = (event) => {
    setFileName(event.target.files[0].name);
    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {

        const rowsArray = [];
        const valuesArray = [];

        results.data.forEach((d) => {
          rowsArray.push(Object.keys(d));
          valuesArray.push(Object.values(d));
        });

        // Filtered Column Names
        setTableRows(rowsArray[0]);
        // Filtered Values
        setValues(valuesArray);

        let val = 25;
        setQuantidadeDisplay(valuesArray.length < val ? valuesArray.length : val)
      },
    });



    //console.log(tableRows, values)
  };

  async function submitAprovados() {
    setLoading(true);

    let formData = new FormData();
    formData.append("arquivo", inputFile.current.files[0]);

    let request = {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: user.token,
      },
      body: formData,
    };

    await fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/UploadArquivoClassificados?funcionalidade=aprovadosProcessoSeletivo`, request)
      .then((response) => response.json())
      .then((result) => {
        if (!result.success)
          return Swal.fire({
            title: "Erro!",
            text: "Verifique se o arquivo enviado é compatível com o exemplo.",
            icon: "error",
            ...swalTheme,
          });

        if (result.success)
          if (result.payload.length) return Swal.fire({
            title: "Alerta!",
            text: `Lista de aprovados foi importada, mas os e-mails seguintes contém algum problema e não puderam ser importados; ${result.payload.toString()}.`,
            icon: "warning",
            ...swalTheme,
          });

        return Swal.fire({
          title: "Sucesso!",
          text: "Upload de arquivo realizado com sucesso!",
          icon: "success",
          ...swalTheme,
        });
      })
      .catch((error) => console.log("error", error))
      .finally(() => setLoading(false));
  }

  return (
    <>
      <AlignCenter>
        <section>
          <img src={logo} className={styles.logo} alt="logo" />
        </section>
      </AlignCenter>
      <h1>Lista de Aprovados</h1>
      <br />

      <ContainedBtn
        className={styles.button}
        onClick={(e) => {
          e.preventDefault()
          window.location.href = exemplo
        }}
      >
        <FontAwesomeIcon icon={faDownload} /> Exemplo
      </ContainedBtn>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          submitAprovados();
        }}
      >
        <AlignCenter>
          <InputFile
            className={styles.fileLabel}
            {...inputFile.current}
            ref={inputFile}
            label="Enviar arquivo CSV"
            type="file"
            name="arquivo"
            accept=".csv"
            onChange={changeHandler}
            icon={<FontAwesomeIcon icon={faFileArrowUp} />}
          />
        </AlignCenter>

        {!!inputFile.current.files?.length && (
          <>
            <h2 className={styles.fileName}>Aprovados: {fileName} </h2>

            <input
              label="Quantidade"
              type="number"
              value={quantidadeDisplay}
              onChange={(e) => setQuantidadeDisplay(e.target.value)}
              min={1}
              max={values.length}
            />

            <div className={styles.containerTable}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    {tableRows.map((rows, index) => {
                      return <th key={index}>{rows}</th>;
                    })}
                  </tr>
                </thead>

                <tbody className={styles.tbody}>
                  {values
                    .slice(0, quantidadeDisplay)
                    .map((value, index) => {
                      return (
                        <tr key={index}>
                          {value.map((val, i) => {
                            return <td key={i}>{val}</td>;
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <br />
            <ContainedBtn className={styles.button} disabled={loading}> {loading ? "Carregando..." : "Enviar"} </ContainedBtn>
          </>
        )}
      </form>

    </>
  );
}

export default RecodeproAprovados;
